import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AuthModule } from '../../../auth/auth.module';
import { TermsAndConditionsComponent } from './t.and.c.modal.component';

@NgModule({
    declarations: [TermsAndConditionsComponent],
    imports: [BrowserModule, AuthModule],
    exports: [TermsAndConditionsComponent]
})

export class TermsAndConditionsModalModule {}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/components/common/terms.and.conditions.modal/t.and.c.modal.module.ts